import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MessageConfig } from '../models/messageConfig';

@Injectable({
  providedIn: 'root'
})

export class MessageService {

  private _messageSource = new Subject<MessageConfig>()
  message$ = this._messageSource.asObservable()

  constructor() { }

  hied(){
    this._messageSource.next({color: 'green', msg: '', visible: false})
  }

  success(msg: string){
    this._messageSource.next({color: 'green', msg: msg, visible: true})
  }
  
  error(msg: string){
    this._messageSource.next({color: 'red', msg: msg, visible: true})
  }

  warning(msg: string){
    this._messageSource.next({color: 'yellow', msg: msg, visible: true})
  }


}
